import styled from "styled-components";
import { Modal } from "antd";
export const Wrapper = styled(Modal)`
	display: flex;
	justify-content: center;

	.ant-modal-content {
		border-radius: 8px;
		width: 280px;
		top: -200px;
		padding: 16px;
	}
	.ant-modal-body {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
	}
	.button_container {
		width: 80%;
	}
`;
